import React, { memo, useEffect, useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.css';

import styles from './ThreePartAdvert.module.less';
import PartAdvert from '../../components/PartAdvert/PartAdvert';
import { addClass, removeClass } from '../../utils/utils';
import { logging } from '../../actions/log';
import { useInView } from 'react-intersection-observer';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectLocalSoftsInit = createSelector(
  state => state.native,
  native => native.installedSoftInit,
);

export default memo(({ data, logInfo }) => {
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const localSoftsInit = useSelector(selectLocalSoftsInit);

  const [showData, setShowData] = useState({});

  const LOG_ACTION_SOURCE = {
    c_action: `${logInfo.tag}_HotSell`,
    c_hover: `${logInfo.tag}_HotSell_hover`,
    c_change: `${logInfo.tag}_HotSell_change`,
    source: `${logInfo.tag}_HotSell`,
  };

  const swiperEl = useRef(null);
  const swiperNext = useRef(null);
  const swiperPrev = useRef(null);
  const swiperParams = {
    speed: 600,
    slidesPerView: 'auto',
    slidesPerGroup: 3,
    spaceBetween: 12,
    allowTouchMove: false,
  };
  const [ref, inView] = useInView({
    threshold: 1,
  });
  const [refDom, inViewDom] = useInView({
    threshold: 0,
  });

  useEffect(() => {
    if (inView && logInfo && logInfo.changView) {
      logInfo.changView({
        pageCardId: data && data.dataList && data.dataList[0] && data.dataList[0].pageCardContentId,
        pageCardTitle: data && data.title,
        rankCode: data && data.dataList && data.dataList[0] && data.dataList[0].code,
        cardType: data && data.cardType,
        org: data && data.dataList && data.dataList[0] && data.dataList[0].org,
      });
    }
  }, [inView]);

  // 筛洗数据，去除运营配置数据错误情况
  useEffect(() => {
    if (
      data &&
      data.dataList &&
      data.dataList.length > 0 &&
      data.dataList[0] &&
      data.dataList[0].advertList
    ) {
      setShowData(data.dataList[0]);
    }
  }, [dispatch, localSoftsInit, data]);

  const handleShowNextPrev = useCallback(
    flag => {
      if (swiperEl && swiperEl.current && swiperEl.current.swiper) {
        const swiperObj = swiperEl.current.swiper;
        if (flag === 'next') {
          swiperObj.slideNext();
        }
        if (flag === 'prev') {
          swiperObj.slidePrev();
        }
        if (swiperPrev && swiperPrev.current && swiperNext && swiperNext.current) {
          swiperObj.isEnd
            ? addClass(swiperNext.current, styles.swiper_soft_hidden)
            : removeClass(swiperNext.current, styles.swiper_soft_hidden);
          swiperObj.isBeginning
            ? addClass(swiperPrev.current, styles.swiper_soft_hidden)
            : removeClass(swiperPrev.current, styles.swiper_soft_hidden);
        }

        dispatch(
          logging({
            category: 'C',
            action: LOG_ACTION_SOURCE.c_change,
            label: '',
            param2: {
              source: `${LOG_ACTION_SOURCE.source}||${showData.pageCardContentId || ''}`,
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
              title: data.title,
              pageCardContentId: showData.pageCardContentId,
              nextOrPrev: flag,
              pageNum: swiperObj.snapIndex + 1,
            },
          }),
        );
      }
    },
    [dispatch, swiperEl, swiperNext, swiperPrev, showData],
  );

  return showData && showData.advertList && showData.advertList.length > 2 ? (
    <div
      className={inViewDom ? styles.card_cardIn : styles.card_cardOut}
      ref={ref}
      data-item={data.cardType}
    >
      <div className={styles.card} ref={refDom}>
        {inViewDom && (
          <>
            <div className={styles.card_header}>
              <div className={styles.card_header_title}>{data.title}</div>
            </div>
            <div className={styles.card_softs}>
              <Swiper {...swiperParams} ref={swiperEl}>
                {showData.advertList.map((item, i) => (
                  <div key={i} className={styles.swiper_soft}>
                    <PartAdvert
                      data={item}
                      logInfo={{
                        ...logInfo,
                        c_action: LOG_ACTION_SOURCE.c_action,
                        source: `${LOG_ACTION_SOURCE.source}||${showData.pageCardContentId || ''}`,
                        source_p: logInfoData.source_p,
                        source_pp: logInfoData.source_pp,
                      }}
                      key={i}
                    />
                  </div>
                ))}
              </Swiper>
              <div
                className={`${styles.swiper_soft_prev} ${styles.swiper_soft_hidden}`}
                onClick={() => {
                  handleShowNextPrev('prev');
                }}
                ref={swiperPrev}
              />
              {showData.advertList.length > 3 && (
                <div
                  className={styles.swiper_soft_next}
                  onClick={() => {
                    handleShowNextPrev('next');
                  }}
                  ref={swiperNext}
                />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  ) : (
    ''
  );
});
